import { IPushNotification } from '@common/model/pushNotifications';

export enum PushNotificationsStatus {
  Unknown,
  NotAvailable,
  AddingToHomeScreenRequired,
  NotSubscribed,
  Subscribed,
}

export enum PushNotificationsEvent {
  NotificationReceived = 'notificationReceived',
  NotificationClicked = 'notificationClicked',
}

export interface IPushNotificationsEventListener {
  (ev: MessageEvent<{ event: PushNotificationsEvent; notification: IPushNotification }>): void;
}

export interface IPushNotificationsManagerOptions {
  /**
   * Public VAPID key for push notifications sending
   */
  applicationServerKey?: string | null;

  onStatusUpdated?: (status: PushNotificationsStatus) => void;

  /**
   * Called when subscription created by user action or retrieved existed subscription.
   * Existed subscription should be saved inside this callback. If error occured during
   * this process, status will be changed to "NotSubscribed".
   * @param subscription
   * @returns void | Promise<void>
   */
  onSubscriptionExists?: (subscription: PushSubscriptionJSON) => void | Promise<void>;
}

export interface IPushNotificationsManager {
  /**
   * Trigger subscription proccess. If subscription do not exists,
   * prompt for subscription allowing will be shown to the user
   */
  subscribe(): Promise<void>;

  /**
   * Checks whether subscription exists or not
   */
  checkSubscription(): Promise<void>;

  /**
   * Inicates whether subscription retieved from user agent (web browser) and saved
   */
  get status(): PushNotificationsStatus;

  /**
   * Push notification subscription detected for current user agent
   */
  get subscription(): PushSubscriptionJSON | undefined;

  /**
   * Subscribing to push notification events
   */
  addEventListener(listener: IPushNotificationsEventListener): void;

  /**
   * Unsubscribing from push notification events
   */
  removeEventListener(listener: IPushNotificationsEventListener): void;
}

export interface IPushNotificationsContext {
  manager: IPushNotificationsManager;
  status: PushNotificationsStatus;
}
